import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: config.serverUrl,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const lineOfficialNotificationApi = {
  getLineOfficialNotificationList: (request) => {
    const { params } = request
    return instance().get(`api/line-official-notification/cms/broadcast`, { params })
  },
  createLineOfficialNotificationBroadcast: (request) => {
    const { data } = request
    return instance().post(`api/line-official-notification/cms/broadcast`, data)
  },
  editLineOfficialNotificationBroadcast: (request) => {
    const { data } = request
    return instance().put(`api/line-official-notification/cms/broadcast`, data)
  },
  deleteLineOfficialNotificationBroadcast: (request) => {
    const { data } = request
    return instance().delete(`api/line-official-notification/cms/broadcast`, {
      data
    })
  },
  getLogLineOfficialNotificationBroadcast: (request) => {
    const { params } = request
    return instance().get(`api/line-official-notification/cms/broadcast/log`, {
      params
    })
  }
}
export default lineOfficialNotificationApi



// WEBPACK FOOTER //
// ./src/api/line-official-notification.js